import {useUserStore} from '@/store/user'
import {User} from 'oidc-client-ts'
import jwt_decode from 'jwt-decode'
import {getRegionForSalesArea} from '~/assets/js/utils/region_service'
import type {KeycloakTokenPayload} from './types'

export function decodeKeycloakToken(accessToken: string): KeycloakTokenPayload {
  return jwt_decode(accessToken) as KeycloakTokenPayload
}

export function restoreUserStoreFromAccessToken(accessToken: string) {
  const userStore = useUserStore()
  const decodedToken = decodeKeycloakToken(accessToken)

  userStore.setAccessToken(accessToken)

  if (decodedToken.oid) {
    userStore.setUserUuid(decodedToken.oid)
  }
  if (decodedToken.name) {
    userStore.setUserName(decodedToken.name)
  }

  return decodedToken
}

export function buildKeycloakUser(accessToken: string, idToken: string | undefined, refreshToken: string | undefined, state: any) {
  const decodedToken = decodeKeycloakToken(accessToken)
  const subject = decodedToken.oid ?? ''

  return new User({
    id_token: idToken ?? '',
    access_token: accessToken,
    refresh_token: refreshToken ?? '',
    token_type: 'Bearer',
    scope: decodedToken.scope ?? 'openid profile email',
    profile: {
      sub: subject,
      name: decodedToken.name,
      oid: subject,
      ...decodedToken
    } as any,
    session_state: null,
    expires_at: decodedToken.exp ?? (Math.floor(Date.now() / 1000) + 3600),
    userState: state
  })
}

export function getTokenRegion(accessToken: string) {
  const decodedToken = decodeKeycloakToken(accessToken)
  return decodedToken.salesAreaName
    ? getRegionForSalesArea(decodedToken.salesAreaName.replaceAll('_', '-'))
    : null
}
